import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Drawer } from '@mafc/trolly';

import { Entry, Product, ServiceProductsType } from 'network/response/ICart';
import useExtendedWarrantyItem from './hooks/useExtendedWarrantyItem.hook';

import { useState } from 'react';
import ExtendedWarrantyDrawer from './ExtendedWarrantyDrawer';
import Stripe from './Stripe';
interface Props {
  entryNumber?: Entry['entryNumber'];
  productEntryNumber: Entry['entryNumber'];
  pid: Product['code'];
  initialSelectedCode?: Product['code'];
  serviceProducts: ServiceProductsType;
  quantity?: number;
  offerId?: string;
}
const ExtendedWarrantyItem: React.FC<Props> = ({
  entryNumber,
  initialSelectedCode = '',
  serviceProducts,
  ...rest
}) => {
  const [selectedCode, updateWarranty] = useExtendedWarrantyItem(initialSelectedCode, rest);
  const { t } = useTranslation();

  const [isOpen, updateOpen] = useState(false);
  const toggleDrawer = useCallback(() => {
    updateOpen(!isOpen);
  }, [updateOpen, isOpen]);

  const checkedWarranty = useMemo(() => {
    return serviceProducts.filter(({ code }) => {
      return code === selectedCode;
    });
  }, [selectedCode, serviceProducts]);
  const isCheckedWaranty = checkedWarranty.length > 0;
  const { yearOfWarranty: selectedWarranty, price: selectedPrice } = isCheckedWaranty
    ? checkedWarranty[0]
    : serviceProducts[0];
  const removeWarranty = useCallback(() => {
    updateWarranty('');
  }, [updateWarranty]);
  return (
    <>
      <Box mt={2} data-testid="extended-warranty">
        <Stripe
          yearOfWarranty={selectedWarranty}
          onClick={isCheckedWaranty ? removeWarranty : toggleDrawer}
          price={selectedPrice}
          isChecked={checkedWarranty.length > 0}
          variant={isCheckedWaranty ? 'success' : 'info'}
        />
      </Box>

      {isOpen ? (
        <Drawer
          onClose={toggleDrawer}
          isOpen={isOpen}
          width={[null, null, '480px']}
          anchor={['bottom', null, 'right']}
          contentStyles={{
            p: [2, 4],
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            fontFamily: 'Montserrat',
          }}
          variant="float"
          title={<Box fontSize={[2, 4]}>{t('extendedWarntyTitle')}</Box>}
          isTitleBorder={false}
        >
          <ExtendedWarrantyDrawer
            updateWarranty={updateWarranty}
            entryNumber={entryNumber}
            toggleDrawer={toggleDrawer}
            selectedCode={selectedCode}
            serviceProducts={serviceProducts}
          />
        </Drawer>
      ) : null}
    </>
  );
};

export default ExtendedWarrantyItem;
